import GATSBY_COMPILED_MDX from "/root/repo/src/whatsnew/whatsnew/tr/flow/1.3.md";
import {graphql} from 'gatsby';
import React from 'react';
import WhatsNew from '../components/WhatsNew';
const WhatsNewContainer = ({data, children, pageContext: {slug, showNav}}) => {
  const {excerpt, frontmatter: {title, description, date, cover, toc, app}, tableOfContents} = data.mdx;
  if (showNav) slug = slug.replace('/whatsnew/', '/new/');
  const lang = slug.split('/', 3)[2];
  const image = cover ? cover.childImageSharp.resize : null;
  return React.createElement(WhatsNew, {
    title: title,
    description: description,
    excerpt: excerpt,
    image: image,
    slug: slug,
    date: date,
    lang: lang,
    tableOfContents: toc === false ? null : tableOfContents,
    showNav: showNav,
    app: app
  }, children);
};
WhatsNewContainer
export default function GatsbyMDXWrapper(props) {
  return React.createElement(WhatsNewContainer, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query WhatsNew($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      excerpt
      fields {
        slug
      }
      tableOfContents
      frontmatter {
        title
        description
        app
        date
        toc
        cover {
          childImageSharp {
            ...thumbnail
          }
        }
      }
    }
  }
`;
